import { post } from './base';
import constants from '../../config/constants';

export const postMethod = (endPoint, jsonData) => {
    const url = constants.BASE_URL + endPoint;
    return post(url, { jsonData });
};
